import store from 'store';
import {
  SynchronizeController,
  STATE,
} from 'services/3dviewer/moving-controls/synchronizeController';
import i18n from 'i18n';
import { isTrustedOrigin, isFloorViewerCommandMessage } from './utils';
import {
  FLOOR_VIEWER_COMMANDS,
  FLOOR_VIEWER_NAVIGATE_KINDS,
  FLOOR_VIEWER_SETTINGS_KINDS,
} from './schema';

function handleInboundNavigateCommand(message) {
  const { payload } = message;
  if (!payload || typeof payload !== 'object') return;

  switch (payload.kind) {
    case FLOOR_VIEWER_NAVIGATE_KINDS.CHANGE_FLOOR: {
      const state = store.getState();
      const { building, currentRenderIndex } = state;
      let targetIndex = null;

      if (typeof payload.floorIndex === 'number') {
        targetIndex = payload.floorIndex;
      } else if (payload.floorId && building && building.floorList) {
        building.floorList.forEach((floor, index) => {
          if (floor.id === payload.floorId) {
            targetIndex = index;
          }
        });
      }

      if (
        targetIndex === null ||
        !building ||
        !Array.isArray(building.floorList) ||
        targetIndex < 0 ||
        targetIndex >= building.floorList.length ||
        targetIndex === currentRenderIndex
      ) {
        return;
      }

      SynchronizeController.changeFloor(targetIndex);
      break;
    }

    case FLOOR_VIEWER_NAVIGATE_KINDS.GOTO_HOTSPOT: {
      const { hotspotId } = payload;
      if (!hotspotId) return;

      let targetHotspot = null;

      const { leftScene, rightScene } = SynchronizeController;
      if (!leftScene) return;

      const scenes = [];
      if (leftScene.currentSceneInfo) {
        scenes.push(leftScene.currentSceneInfo);
      }
      if (rightScene && rightScene.currentSceneInfo) {
        scenes.push(rightScene.currentSceneInfo);
      }

      scenes.forEach(info => {
        if (!info || !info.hotspots) return;
        if (info.hotspots[hotspotId] && info.hotspots[hotspotId][hotspotId]) {
          targetHotspot = info.hotspots[hotspotId][hotspotId];
        }
      });

      if (!targetHotspot) return;

      SynchronizeController.hotspot2AnyHotspot(targetHotspot);
      break;
    }

    case FLOOR_VIEWER_NAVIGATE_KINDS.SET_VIEW: {
      const { viewState } = payload;
      const { viewButton } = store.getState();
      if (!viewButton) return;
      const { goDown, goUp, toOrthographics } = viewButton;

      if (viewState === STATE.FPVIEW && typeof goDown === 'function') {
        goDown();
      } else if (viewState === STATE.TOPVIEW && typeof goUp === 'function') {
        goUp();
      } else if (
        viewState === STATE.FLOORPLAN &&
        typeof toOrthographics === 'function'
      ) {
        toOrthographics();
      }
      break;
    }

    case FLOOR_VIEWER_NAVIGATE_KINDS.SYNC_FROM_URL: {
      const { query } = payload;
      if (!query || typeof query !== 'object') return;
      const { queryStringList } = store.getState();
      const merged = { ...(queryStringList || {}), ...query };
      store.dispatch({ type: 'SET_QUERY_STRING', queryString: merged });
      break;
    }

    default:
      break;
  }
}

function handleInboundSettingsCommand(message) {
  const { payload } = message;
  if (!payload || typeof payload !== 'object') return;

  switch (payload.kind) {
    case FLOOR_VIEWER_SETTINGS_KINDS.CHANGE_LOCALE: {
      const { locale } = payload;
      if (!locale || typeof locale !== 'string') return;
      i18n.changeLanguage(locale);
      break;
    }
    default:
      break;
  }
}

export function attachInboundBridge() {
  if (typeof window === 'undefined') return () => {};

  const handler = event => {
    const { origin, data } = event;

    if (!isTrustedOrigin(origin)) return;
    if (!isFloorViewerCommandMessage(data)) return;

    if (data.command === FLOOR_VIEWER_COMMANDS.NAVIGATE) {
      handleInboundNavigateCommand(data);
    } else if (data.command === FLOOR_VIEWER_COMMANDS.SETTINGS) {
      handleInboundSettingsCommand(data);
    }
  };

  window.addEventListener('message', handler);

  return () => {
    window.removeEventListener('message', handler);
  };
}
